import { LOCATION_CHANGED } from '../ducks/routing.duck';
import { SIGNUP_SUCCESS } from '../ducks/auth.duck';

// Create a Redux middleware from the given analytics handlers. Each
// handler should have the following methods:
//
// - trackPageView(canonicalPath, previousPath): called when the URL is changed
// - trackSignUp() [optional]: called when a user successfully completes email sign-up
export const createMiddleware = handlers => store => next => action => {
  const { type, payload } = action;

  if (type === LOCATION_CHANGED) {
    const previousPath = store?.getState()?.routing?.currentCanonicalPath;
    const { canonicalPath } = payload;
    handlers.forEach(handler => {
      handler.trackPageView(canonicalPath, previousPath);
    });
  }

  if (type === SIGNUP_SUCCESS) {
    handlers.forEach(handler => {
      if (typeof handler.trackSignUp === 'function') {
        try {
          handler.trackSignUp();
        } catch (e) {
          // Never let analytics errors block the signup flow
          console.error('Analytics trackSignUp error:', e);
        }
      }
    });
  }

  next(action);
};
